export { default as FollowUpHistoryResult } from './FollowUpHistoryResult.vue';
